//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Query from "./components/query/Query.vue";
import Results from "./components/results/Results.vue"
import Pagination from "./components/pagination/Pagination.vue"
export default {
  name: "VitalantDocumentFormListing",
  components: {
		Query,
    Results,
    Pagination
  },
  data() {
      return {
        params: null
      }
  },
  methods: {
    handlePresearch({done, extend, extended}) {
      // Grab url data and create presearch object
      //const url = new URL(document.URL)
      //const params = new URLSearchParams(url.search)

      // odd condition to check if urlsearchparams actually has anything
      // It works so good enough?
      //
      
        extended.presearch = {}
      
        extend(extended => {
          // add presearch data if url query contains it
          if(this.params.has('category')) extended.presearch.category = this.params.get('category')
          if(this.params.has('service')) extended.presearch.service = this.params.get('service')
          if(this.params.has('state')) extended.presearch.state = this.params.get('state')
          return extended
        })
      
      done()
    }
  },
  created () {
    this.params = new URLSearchParams(window.location.search)
  }
};
